import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VMain,[_c(_vm.formComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }